
export default {
  path: '/index',
  name: 'index',
  component: () => import('@/views/Page.vue'),
  children: [
    {
      path: 'guide',
      component: () => import('@/components/index/Guide.vue'),
      meta: {
        title: '推推引导页'
      }
    },
    {
      path: 'qrcode',
      component: () => import('@/components/index/Qrcode.vue'),
      meta: {
        title: '会议室签到'
      }
    },
    {
      path: 'version',
      component: () => import('@/components/index/Version.vue'),
      meta: {
        title: '版本记录'
      }
    },
    {
      path: 'version/details',
      component: () => import('@/components/index/VersionDetails.vue'),
      meta: {
        title: '版本详情'
      }
    },
    {
      path: 'costs',
      component: () => import('@/components/index/StandardCosts.vue'),
      meta: {
        title: '出差费用标准'
      }
    },
    {
      path: 'parking',
      component: () => import('@/components/index/Parking.vue'),
      meta: {
        title: '停车位费用标准'
      }
    },
    {
      path: 'reimburse',
      component: () => import('@/components/index/Reimburse.vue'),
      meta: {
        title: '费用报销引导页'
      }
    },
  ]
}
